var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{staticClass:"text-center"},[_c('v-col',{attrs:{"cols":"12"}},[_c('Cartera')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }